export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/noop.js
// module id = 141
// module chunks = 0